import React, {useState} from "react";
import "./Contact.css";
import Footer from "../../general/footer/Footer";
import axios from "axios";

const QuoteSection = () => {
  const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  subject: "",
});

        const [responseMsg, setResponseMsg] = useState('');



const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData((prevData) => ({
    ...prevData,
    [name]: value,
  }));
};


const handleSubmit = async (e) => {
  e.preventDefault();
    setResponseMsg('');

  try {
    const response = await axios.post(
      "http://localhost:3004/api/send-enquiry",
      formData
    );

          setResponseMsg('Message sent! Our Team will connect with you shortly.');
      setTimeout(() => {
        setResponseMsg('');
        }, 3000)

    setFormData({ name: "", phone: "", email: "", subject: "" });
  } catch (error) {
              setResponseMsg('Something went wrong. Please try again.');
      setTimeout(() => {
        setResponseMsg('');
        }, 3000)

  }
};


  return (
    <>
      <section className="blog-section">
        <div className="blog-heading">
          <span className="blog-label">Contact</span>
          <h2 className="blog-title">
             <span className="highlight">You Are Always</span> Welcome
          </h2>
          <p className="blog-description">
            At PSJ Capital Ventures, we redefine your Wealth Creation journey. Discover the PSJ Capital Ventures Difference –
            a commitment to excellence, integrity, and personalized strategies for your ultimate
            financial growth.
          </p>
        </div>
      </section>

      <div className="quote-section">
        {/* Form Section */}
        <div className="quote-form">
          <h2>
            Contact with us
            <br /> <span> right away.</span>
          </h2>

{responseMsg && <p className='fw-semibold text-muted text-decoration-underline fst-italic'>{responseMsg}</p>}

<form onSubmit={handleSubmit}>
  <input
    type="text"
    name="name"
    placeholder="Your Name Here"
    required
    value={formData.name}
    onChange={handleChange}

  />
  <input
    type="tel"
    name="phone"
    placeholder="Your Phone Number"
    required
    value={formData.phone}
    onChange={handleChange}
  />
  <input
    type="email"
    name="email"
    placeholder="Your Email Here"
    required
    value={formData.email}
    onChange={handleChange}
  />
  <input
    type="text"
    name="subject"
    placeholder="Enter Subject"
    required
    value={formData.subject}
    style={{height: '8em'}}
    onChange={handleChange}
  />
  <button className="submit-btn" type="submit">Submit Now</button>
</form>

        </div>

        {/* WhatsApp Section */}
        <div className="quote-whatsapp">
          <h3>WhatsApp Us</h3>
          <p>Need instant support? Connect with us directly via WhatsApp.</p>
          <a
            href="https://wa.me/918108430942"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-btn"
          >
            <i className="fa-brands fa-whatsapp"></i> Chat on WhatsApp
          </a>
        </div>
      </div>
    <br></br><br></br>
      <Footer />
    </>
  );
};

export default QuoteSection;
